module.exports = __webpack_public_path__ + "img/WAKE_LOCKED_WHITE.ea93b2fd.png";